import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MainPageService } from './main-page.service';
import { IJobOffer, ButtonSize, ButtonState, ButtonType } from '../../../../../assets/types/dtoTypes';
import { BreakpointsService, BIPPERZ_BREAKPOINTS } from '../../../../shared/services/breakpoint.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../../shared/services/notifications.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import {ExternalHeaderComponent} from "../../../../shared/external-header/external-header.component";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {JobOfferCardComponent} from "./job-offer-card/job-offer-card.component";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {SearchBarComponent} from "../../../../shared/search-bar/search-bar.component";
import {FooterComponent} from "../../../../shared/footer/footer.component";
import {LoadMaskComponent} from "../../../../shared/load-mask/load-mask.component";
import {ConsultationBannerComponent} from "../../../../shared/consultation-banner/consultation-banner.component";


@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  imports: [
    ExternalHeaderComponent,
    TranslateModule,
    JobOfferCardComponent,
    RouterLink,
    SearchBarComponent,
    FooterComponent,
    NgIf,
    NgForOf,
    LoadMaskComponent,
    NgClass,
    ConsultationBannerComponent
  ],
  standalone: true
})
export class MainPageComponent implements OnInit, OnDestroy {
  private mainPageService = inject(MainPageService);
  private breakpointsService = inject(BreakpointsService);
  private notificationService = inject(NotificationService);
  private authenticationService = inject(AuthenticationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  isMobile = false;

  isLoading = false;

  jobOffers: IJobOffer[] = [];

  filteredOffers: IJobOffer[] = [];

  selectedCategory: string = 'All';

  searchTerm = '';

  ButtonType = ButtonType;

  ButtonSize = ButtonSize;

  ButtonState = ButtonState;

  private breakpointSubscription!: Subscription;

  constructor() {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.authenticationService.setAccessToken(token);
      this.router.navigate([], { queryParams: {}, replaceUrl: true });
    }
    this.isLoading = true;
    this.fetchJobOffers();

    this.notificationService.onOfferCreated().subscribe( ( offer ) => {
      if ( offer ) {
        this.fetchJobOffers();
      }
    } );

    this.breakpointSubscription = this.breakpointsService
      .observe( [ BIPPERZ_BREAKPOINTS.s, BIPPERZ_BREAKPOINTS.m_down ] )
      .subscribe( ( result ) => {
        this.isMobile = result.s || result.m_down;
      } );
  }

  private fetchJobOffers(): void {
    this.mainPageService.getJobOffers().subscribe((data) => {
      this.jobOffers = data.sort((a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );

      this.filteredOffers = [...this.jobOffers];
      this.isLoading = false;
    });
  }

  applySearchFromBar(filtered: any[]): void {
    this.filteredOffers = filtered.sort((a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  ngOnDestroy(): void {
    if ( this.breakpointSubscription ) {
      this.breakpointSubscription.unsubscribe();
    }
  }
}
